import React from "react";
import "./IntroMenu.css";
import Imagens from "../../../../components/IMAGESCOMPONENT/ImageComponent";

const receitas = [
  {
    titulo: "Cheesecake fria com Calda de Frutas Vermelhas",
    descricao:
      "Cheesecake suave, coberto com calda de frutas vermelhas, a sobremesa perfeita para adoçar momentos...",
    data: "16/12/2025",
    imagem: Imagens.Receita1,
  },
  {
    titulo: "Canapé de Choripán com Vinagrete de Manga e Castanha Picante",
    descricao:
      "Canapé de Choripán com Vinagrete de Manga e Castanha Picante, a combinação perfeita de...",
    data: "15/12/2025",
    imagem: Imagens.Receita2,
  },
  {
    titulo: "Wok Asiático com Mignon Caramelizado e Stealth",
    descricao:
      "Texturas, contraste e aquele sabor agridoce que conquista logo na primeira garfada. Quer surpreender...",
    data: "15/12/2025",
    imagem: Imagens.Receita3,
  },
  {
    titulo: "Picanha na parrilla com purê de abóbora e batata rústica",
    descricao:
      "A idéia deste prato é deixar elegante, requintado e sofisticado. Uma apresentação bem gourmet.",
    data: "15/12/2025",
    imagem: Imagens.Receita4,
  },
  {
    titulo: "Ceviche de Camarão com Pistache",
    descricao:
      "Uma entrada leve, elegante e cheia de textura pra impressionar em qualquer ocasião. Já...",
    data: "15/12/2025",
    imagem: Imagens.Receita2,
  },
];

const IntroMenu = ({ titulo, abrirDetalhes }) => {
  return (
    <div className="intro-menu-wrapper">
      <h2 className="intro-menu-title">{titulo}</h2>

      <div className="intro-menu-cards">
        {receitas.map((receita, index) => (
          <div 
            key={index} 
            className="menu-card" 
            onClick={abrirDetalhes} // todo card clicável
          >
            <img
              src={receita.imagem}
              alt={receita.titulo}
              className="menu-card-img"
            />

            <div className="menu-card-body">
              <h3 className="menu-card-title">{receita.titulo}</h3>
              <p className="menu-card-desc">{receita.descricao}</p>

              <div className="menu-card-footer">
                <span className="menu-card-date">{receita.data}</span>
                
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntroMenu;
